import { useState, useEffect } from "react";
import styles from "./ProgressBar.module.css";

interface ProgressBarProps {
    label?: string[];
    state: number;
    animatedMessages?: string[];
}

const ProgressBar = (props: ProgressBarProps) => {
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(true);

    // 메시지 순환 애니메이션
    useEffect(() => {
        if (!props.animatedMessages || props.animatedMessages.length === 0) return;

        const interval = setInterval(() => {
            setIsVisible(false);

            setTimeout(() => {
                setCurrentMessageIndex((prev) => {
                    if (!props.animatedMessages) return 0;
                    return (prev + 1) % props.animatedMessages.length;
                });
                setIsVisible(true);
            }, 1000); // fade out 시간
        }, 4500); // 2초마다 변경

        return () => clearInterval(interval);
    }, []); // dependency 제거하여 마운트 시 한 번만 실행

    return (
        <div className={styles.wrapper}>
            <div className={styles.label}>
                {props.label && props.label[0] && (
                    <span className={styles.title}>{props.label[0]}</span>
                )}
                {props.animatedMessages && props.animatedMessages.length > 0 && (
                    <span
                        className={`${styles.animatedMessage} ${isVisible ? styles.visible : styles.hidden}`}
                    >
                        {props.animatedMessages[currentMessageIndex]}
                    </span>
                )}
            </div>
            <div className={styles.bar}>
                <div className={styles.progressBarContainer}>
                    <div
                        className={styles.progressBarFill}
                        style={{ width: `${props.state}%` }}
                    />
                </div>
                <span className={styles.value}>{`${props.state}%`}</span>
            </div>
        </div>
    );
};

export default ProgressBar;
